import React, { Component } from 'react';
import PropTypes from 'prop-types';

// import classNames from 'classnames';
// import { DateRangePicker, isInclusivelyBeforeDay, SingleDatePicker } from 'react-dates';
import moment from 'moment';

import Table from './Table/Table';
import DashboardFilter from '../../../../components/_molecules/DashboardFilter/DashboardFilter';
import Button from '../../../../components/_atomic/Button/Button';
import {
  DASHBOARD_FILTERS_NAMES,
  TEXT_FIELD_STATUS,
  ERROR,
} from '../../../../utils/constants';
import './TablePart.scss';
import { formatRequestDate } from '../../../../utils/helpers';
import CustomMultiSelectEvent from '../../../../components/_molecules/CustomMultySelectEvent/CustomMultySelectEvent';
// import SwitchGroup from '../../../../components/_molecules/SwitchGroup/SwitchGroup';


// const arrowIcon = require('../ChartPart/assets/arrow.svg');

const campaignStatusFilterName = 'campaign-status';
const campaignStatusValues = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
];

/* const switchDatePickerType = [
  {
    label: 'Date',
    value: 'DATE',
  },
  {
    label: 'Range',
    value: 'RANGE',
  },
]; */

class TablePart extends Component {
  static propTypes = {
    campaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getTableReport: PropTypes.func.isRequired,
    tableReport: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    appId: PropTypes.number.isRequired,
    patchCampaign: PropTypes.func.isRequired,
    patchCampaignStatus: PropTypes.string.isRequired,
    navigateToCampaign: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
    navigateToUserLogs: PropTypes.func.isRequired,
    getEvents: PropTypes.func.isRequired,
    updateEvents: PropTypes.func.isRequired,
    setEvents: PropTypes.func.isRequired,
    userId: PropTypes.number,
    // currentDate: PropTypes.string.isRequired,
    updateEventTableAdmin: PropTypes.func.isRequired,
    updateAdminTable: PropTypes.func.isRequired,
    accessedEvents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentEvents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setAdminTable: PropTypes.func.isRequired,
    deleteNotActualTableAdmin: PropTypes.func.isRequired,
    adminTable: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    userTable: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    datePicker: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setUserTable: PropTypes.func.isRequired,
    deleteNotActualTableUser: PropTypes.func.isRequired,
    updateUserTable: PropTypes.func.isRequired,
    updateEventTableUser: PropTypes.func.isRequired,
  };
  static defaultProps = {
    isAdmin: false,
    userId: -1,
  };
  state = {
    filters: {
      [DASHBOARD_FILTERS_NAMES.CAMPAIGN]: {
        value: '',
        status: '',
      },
      [campaignStatusFilterName]: {
        value: '',
        status: '',
      },
    },
    datePicker: {
      startDate: moment().subtract(1, 'month'),
      endDate: moment(),
    },
    // focusedDatePickerInput: null,
    // datePickerTypeSwitchValue: 'RANGE',
  };

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const {
      appId, getTableReport, patchCampaignStatus, getEvents,
    } = this.props;
    if (prevProps.appId !== appId && !Number.isNaN(appId)) {
      getTableReport(this.formatRequestParameters(appId));
      getEvents();
    }

    if (
      prevProps.patchCampaignStatus !== patchCampaignStatus &&
      patchCampaignStatus === ERROR
    ) {
      getTableReport(this.formatRequestParameters(appId));
    }
  }
  componentWillUnmount() {
    const { updateEvents } = this.props;
    updateEvents([]);
  }
  formatRequestParameters = (appId) => {
    const { isAdmin, datePicker } = this.props;
    const parameters = {
      appId,
      isAdmin,
    };
    parameters.to = formatRequestDate(datePicker.endDate);
    parameters.from = formatRequestDate(datePicker.startDate);
    return parameters;
  };

  updateEventsStatus = (ev) => {
    const { setEvents } = this.props;
    setEvents(ev);
  };

  datesChangeHandler = ({ startDate, endDate }) => {
    const datePicker = {
      ...this.state.datePicker,
    };

    datePicker.startDate = startDate;
    datePicker.endDate = endDate;
    const isValidEnd = moment(datePicker.endDate).isValid();
    this.setState(
      () => ({ datePicker }),
      () => {
        if (isValidEnd) {
          const { appId, getTableReport } = this.props;
          getTableReport(this.formatRequestParameters(appId));
        }
      },
    );
  };

  datesFocusHandler = (focusedDatePickerInput) => {
    this.setState(() => ({ focusedDatePickerInput }));
  };

  filterChangeHandler = ({ name, value }) => {
    const filters = {
      ...this.state.filters,
    };
    if (value) {
      filters[name].status = TEXT_FIELD_STATUS.VALID;
    } else {
      filters[name].status = TEXT_FIELD_STATUS.INITIAL;
    }
    filters[name].value = value.value;
    this.setState(() => ({ filters }), () => {});
  };

  navigateToUserLogs = () => {
    const { userId, navigateToUserLogs } = this.props;
    navigateToUserLogs(userId);
  }

  datePickerTypeSwitchChangeHandler = (value) => {
    this.setState(() => ({ datePickerTypeSwitchValue: value }));
  };

  refreshTable = () => {
    const { appId, getTableReport } = this.props;
    if (appId) {
      getTableReport(this.formatRequestParameters(appId));
    }
  };

  updateEventFilterVal = (val) => {
    const { updateEvents } = this.props;
    updateEvents(val);
  };

  render() {
    const {
      filters,
      // datePicker,
      // datePickerTypeSwitchValue,
      // focusedDatePickerInput,
    } = this.state;
    const campaignFilter = filters[DASHBOARD_FILTERS_NAMES.CAMPAIGN];
    const statusFilter = filters[campaignStatusFilterName];
    const {
      campaigns,
      tableReport,
      patchCampaign,
      patchCampaignStatus,
      navigateToCampaign,
      appId,
      isAdmin,
      currentEvents,
      accessedEvents,
      setAdminTable,
      adminTable,
      updateAdminTable,
      updateEventTableAdmin,
      deleteNotActualTableAdmin,
      userTable,
      setUserTable,
      updateUserTable,
      updateEventTableUser,
      deleteNotActualTableUser,
    } = this.props;
    /* const datePickerWrapperClasses = classNames({
      'date-picker-wrapper': true,
      'is-focused': focusedDatePickerInput,
    }); */
    return (
      <div className="table-part">
        <div className="top-table-part">
          {isAdmin ?
            <React.Fragment>
              <DashboardFilter
                label="By status:"
                values={campaignStatusValues}
                status={statusFilter.status}
                value={statusFilter.value}
                name={campaignStatusFilterName}
                changeHandler={this.filterChangeHandler}
              />
              <Button
                label="View logs"
                secondary
                clickHandler={this.navigateToUserLogs}
              />
            </React.Fragment>
          :
            <React.Fragment>
              <DashboardFilter
                label="By campaign:"
                values={campaigns}
                status={campaignFilter.status}
                value={campaignFilter.value}
                name={DASHBOARD_FILTERS_NAMES.CAMPAIGN}
                changeHandler={this.filterChangeHandler}
              />
              <Button
                label="Add New Campaign"
                clickHandler={() => navigateToCampaign({ appId })}
              />
            </React.Fragment>
        }
          {/* <div className={datePickerWrapperClasses}>
            {datePickerTypeSwitchValue === 'RANGE' ? <DateRangePicker
              startDate={datePicker.startDate}
              startDateId="id-start-date"
              endDate={datePicker.endDate}
              endDateId="id-end-date"
              isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
              displayFormat="DD MMMM"
              readOnly
              customArrowIcon="&mdash;"
              focusedInput={focusedDatePickerInput}
              onDatesChange={this.datesChangeHandler}
              onFocusChange={this.datesFocusHandler}
              customInputIcon={<img src={arrowIcon} alt="arrow" />}
            /> : <SingleDatePicker
              date={datePicker.endDate}
              id="date-picker-day"
              displayFormat="DD MMMM"
              readOnly
              focused={focusedDatePickerInput && focusedDatePickerInput.focused}
              customArrowIcon="&mdash;"
              isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
              onDateChange={date => this.datesChangeHandler({ startDate: date, endDate: date })}
              onFocusChange={this.datesFocusHandler}
              customInputIcon={<img src={arrowIcon} alt="arrow" />}
            />}
          </div> */}
          {/* <div className="switch-date-picker-type-wrapper">
            <SwitchGroup
              changeHandler={this.datePickerTypeSwitchChangeHandler}
              value={datePickerTypeSwitchValue}
              values={switchDatePickerType}
            />
          </div> */}
          <div className="button-wrapper refresh-button-just-wrapper">
            <span> Just Block </span>
          </div>
          <CustomMultiSelectEvent
            values={accessedEvents}
            value={currentEvents}
            status={false}
            updateEventFilterVal={this.updateEventFilterVal}
            multi
            closeOnSelect={false}
          />
          <div className="button-wrapper refresh-button-wrapper">
            <button onClick={this.refreshTable} className="refresh-button">Refresh</button>
          </div>
        </div>
        <div className="bottom-table-part">
          <Table
            data={tableReport}
            filter={campaignFilter.value}
            statusFilter={statusFilter.value}
            isAdmin={isAdmin}
            patchCampaign={patchCampaign}
            patchCampaignStatus={patchCampaignStatus}
            currentEvents={currentEvents}
            refreshTable={this.refreshTable}
            adminTable={adminTable}
            setAdminTable={setAdminTable}
            updateEventsStatus={this.updateEventsStatus}
            updateAdminTable={updateAdminTable}
            updateEventTableAdmin={updateEventTableAdmin}
            deleteNotActualTableAdmin={deleteNotActualTableAdmin}
            userTable={userTable}
            setUserTable={setUserTable}
            updateUserTable={updateUserTable}
            updateEventTableUser={updateEventTableUser}
            deleteNotActualTableUser={deleteNotActualTableUser}
            campaignClickHandler={campaignId =>
              navigateToCampaign({ appId, campaignId })
            }
          />
        </div>
      </div>
    );
  }
}

export default TablePart;



// WEBPACK FOOTER //
// ./src/containers/MainPanel/components/TablePart/TablePart.js